import axios from "axios";
import { host, path, port, version } from "../systemVariables";

// Method path
const resource = "/producttaxtypes";

export const LIST_PRODUCTTAXTYPE = "LIST_PRODUCTTAXTYPE";

export function listAllProductTaxTypeAction(callback) {
  return (dispatch) => {
    axios
      .get(host + port + path + version + resource, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        dispatch({ type: LIST_PRODUCTTAXTYPE, payload: response.data });
        callback(response);
      })
      .catch(function (error) {
        return error;
      });
  };
}
